import { css } from "styled-components";
export default css`
    .ant-float-btn .ant-float-btn-body .ant-float-btn-content .ant-float-btn-icon {
        width: initial;
    }
    .ant-float-btn-primary .ant-float-btn-body {
        background-color: #007097;

        &:hover {
            background-color: #14A0FF;
        }
    }
`;